export default __webpack_public_path__ + "static/media/bull.f7f436a9.svg";